/*------------------------------------------------- CONSTANTS -------------------------------------------------*/
    /*
     * Cursor styles constants.
     */
const CURSOR_STYLE_WAIT = "progress"
const CURSOR_STYLE_AUTO = "auto"

    /*
     * Page section IDs. It is assumed that login page interface have the following layout:
     * [HEADER]
     * [TOOLTIP]
     * [ERROR MESSAGES]
     * [FORM]
     * [NOTE] (usually a comment for an error a success message on the page)
     * [BACK TO LOGIN PAGE LINK]
     */
const HEADER_CONTAINER_ID = "headerContainer"
const FORM_CONTAINER_ID = "formContainer"
const TOOLTIP_CONTAINER_ID = "tooltipContainer"
const DEMO_TOOLTIP_CONTAINER_ID = "demoTooltipContainer"
const ERROR_MESSAGE_CONTAINER_ID = "errorSpan"
const ERROR_MESSAGES_AREA_ID = "errorMessagesArea"
const NOTE_CONTAINER_ID = "noteContainer"
const CHANGE_STATE_LINK_CONTAINER_ID = "changeStateLinkContainer"
const CLICK_TOOLTIP_ID = "hover_tooltip"

export function LoginPageController(state) {
    this.inProgress = false
    this.pageState = state
    this.pageState.setController(this)
    this.lastFormContainerId = null
    this.adminEmailAddress = null
    this.printTitleDocument()
}

    LoginPageController.prototype.changeState = function( state )
    {
        if( this.isInProgress() )
            return;
        this.hideAllMessages();
        this.hideForm();
        this.hideChangeStateLink();
        this.pageState = state;
        this.pageState.setController( this );
        this.pageState.clearInputs( this.getForm() );
        this.printTitleDocument();
        this.showPageContent();
    };

    LoginPageController.prototype.toInProgressState = function()
    {
        this.inProgress = true;
        this.getButton().className = "inProgress";
        this.getProgressText().style.visibility = "visible";
        this.setChangeStateLinkDisabled( true );
        this.setCursorStyle(CURSOR_STYLE_WAIT);
    };

    LoginPageController.prototype.toInitialState = function()
    {
        this.getProgressText().style.display = "none";
        this.getButton().className = "initial";
        this.setChangeStateLinkDisabled( false );
        this.inProgress = false;
        this.setCursorStyle(CURSOR_STYLE_AUTO);
    };

    LoginPageController.prototype.showPageContent = function()
    {
        this.printTitle();
        this.printTooltip();
        this.printDemoTooltip();
        this.showForm();
        this.printNote();
        this.initInputs();
        this.showChangeStateLink();
        if (this.pageState.postponedError) {
            this.pageState.processError(this.pageState.postponedError);
        }
    };

    LoginPageController.prototype.printTitleDocument = function(){
        if(this.pageState.titleKey)
             document.title = messageResource.getMessage(this.pageState.titleKey);
        else{
            document.title = messageResource.getMessage("login.page.title.login");
        }
    };

    LoginPageController.prototype.setAdminEmailAddress = function( email ) {
        this.adminEmailAddress = email;
    };

    LoginPageController.prototype.getAdminEmailAddress = function( ) {
        return this.adminEmailAddress;
    };

    /*
     * Disables form autocompletion and focuses username field.
     */
    LoginPageController.prototype.initInputs = function ()
    {
        var form = this.getForm();
        if( !form )
            return;
        var controller = this;
        form.autocompletion = "off";
        var enterKeyHandler = function(evt)
        {
            if( window.event )
                evt = window.event;
            if( evt.keyCode == 13 )
            {
                controller.submitForm( form );
                return false;
            }
        };

        var inputNames = this.getInputNames();

        for( var i = 0; i < inputNames.length; i++ )
            form[ inputNames[i] ].onkeypress = enterKeyHandler;

        form[ this.getFocusElementName() ].focus();
    };

    LoginPageController.prototype.isInProgress = function () {
        return this.inProgress;
    };

    LoginPageController.prototype.printTitle = function( title ) {
        this.printSection( HEADER_CONTAINER_ID,
                           title === undefined ? this.pageState.getTitle() : title );
    };

    LoginPageController.prototype.printError = function( errorText ) {
        this.printSection( ERROR_MESSAGE_CONTAINER_ID, errorText );
        var messagesArea = document.getElementById( ERROR_MESSAGES_AREA_ID );
        if( errorText )
            this.showErrorsArea();
        else
            this.hideErrorsArea();
    };

    LoginPageController.prototype.printTooltip = function( message ) {
        this.printSection( TOOLTIP_CONTAINER_ID,
                           message === undefined ? this.pageState.getTooltip() : message );
        var clickTooltipEl = document.getElementById(CLICK_TOOLTIP_ID);
        if (clickTooltipEl) {
            $(clickTooltipEl).click(() => {
                this.pageState.newClickTooltip().init($("#" + TOOLTIP_CONTAINER_ID)).showAt($(clickTooltipEl), {my: "left center", at: "right center"});
            })
        }
    };

    LoginPageController.prototype.printDemoTooltip = function() {
        this.printSection( DEMO_TOOLTIP_CONTAINER_ID, this.pageState.getDemoTooltip() );
    };

    LoginPageController.prototype.printNote = function( message ){
        var note = message === undefined ? this.pageState.getNote() : message;
        this.printSection( NOTE_CONTAINER_ID, note );
    };

    LoginPageController.prototype.getForm = function() {
        return this.pageState.formId ? document.getElementById( this.pageState.formId ) : null;
    };

    LoginPageController.prototype.showChangeStateLink = function() {
        if( this.pageState.changeStateLinkContainerId )
            document.getElementById( this.pageState.changeStateLinkContainerId ).style.display = "";
    };

    LoginPageController.prototype.hideChangeStateLink = function() {
        if( this.pageState.changeStateLinkContainerId )
            document.getElementById( this.pageState.changeStateLinkContainerId ).style.display = "none";
    };

    LoginPageController.prototype.showForm = function() {
        if( this.pageState.formContainerId )
            document.getElementById( this.pageState.formContainerId ).style.display = "";
    };

    LoginPageController.prototype.hideForm = function() {
       this.lastFormContainerId = this.pageState.formContainerId;
       if( this.pageState.formContainerId )
            document.getElementById( this.pageState.formContainerId ).style.display = "none";
    };

    LoginPageController.prototype.printSection = function( containerId, innerHTML )
    {
        var container = document.getElementById( containerId );
        if( container && innerHTML ){
            container.innerHTML = innerHTML;
            container.style.display = "";
        }
        else if( container )
            container.style.display = "none";
    };

    LoginPageController.prototype.submitForm = function( form ) {
        this.pageState.submitForm( form );
    };

    LoginPageController.prototype.getButton = function() {
        return document.getElementById( this.pageState.buttonId );
    };

    LoginPageController.prototype.getProgressText = function() {
        return document.getElementById( this.pageState.progressTextId );
    };

    LoginPageController.prototype.getChangeStateLink = function() {
        return document.getElementById( this.pageState.changeStateLinkId );
    };

    LoginPageController.prototype.getInputNames = function() {
        return this.pageState.inputElementNames;
    };

    LoginPageController.prototype.getFocusElementName = function() {
        return this.pageState.focusElementName;
    };

    /*
     * Hides server side messages. Called before client side messages showing.
     */
    LoginPageController.prototype.hideServerSideMessages = function()
    {
        var serverSideMessages      = document.getElementById("MessagesTable");
        var serverSideErrorMessages = document.getElementById("ErrorsTable");

        if (serverSideMessages != null) {
            serverSideMessages.style.display = "none";
        }
        if (serverSideErrorMessages != null) {
            serverSideErrorMessages.style.display = "none";
        }
    };

    LoginPageController.prototype.hideClientSideMessages = function()
    {
        var clientSideErrorMessages = document.getElementById("ClientSideErrorMessage");

        if (clientSideErrorMessages != null) {
            clientSideErrorMessages.style.display = "none";
        }
    };

    LoginPageController.prototype.showErrorsArea = function( ) {
        document.getElementById( ERROR_MESSAGES_AREA_ID ).style.display = "";
    };

    LoginPageController.prototype.hideErrorsArea = function( errorText ) {
        document.getElementById( ERROR_MESSAGES_AREA_ID ).style.display = "none";
    };

    LoginPageController.prototype.hideAllMessages = function()
    {
        this.hideServerSideMessages();
        this.hideClientSideMessages();
        this.hideErrorsArea();
    };

    /*
     * Sets cursor style (see corresponding constants).
     */
    LoginPageController.prototype.setCursorStyle = function(cursorStyle) {
        document.body.style.cursor = cursorStyle;
    };

    LoginPageController.prototype.setChangeStateLinkDisabled = function( isDisabled )
    {
        var link = this.getChangeStateLink();
        if( !link )
            return;

        var linkDisabledClass = "disabledLink";
        if( isDisabled )
            addClass( link , linkDisabledClass );
        else
            removeClass( link, linkDisabledClass );
    };









// WEBPACK FOOTER //
// ./web/js/login_page_controller.js